const initialState = {
  bannerLoading: false,
  bannerList: [],
  recommendLoading: false,
  recommendList: [],
  midBanner: [],
};

function reducer(state, action) {
  switch (action.type) {
    case 'setBannerLoading':
      return { ...state, bannerLoading: action.payload };
    case 'setBannerList':
      return { ...state, bannerList: action.payload };
    case 'setRecommendLoading':
      return { ...state, recommendLoading: action.payload };
    case 'setRecommendList':
      return { ...state, recommendList: action.payload };
    case 'setMidBanner':
      return { ...state, midBanner: action.payload };
    default:
  }
}

const setBannerLoading = payload => ({
  type: 'setBannerLoading',
  payload
});

const setBannerList = payload => ({
  type: 'setBannerList',
  payload
});

const setRecommendLoading = payload => ({
  type: 'setRecommendLoading',
  payload
});

const setRecommendList = payload => ({
  type: 'setRecommendList',
  payload
});

const setMidBanner = payload => ({
  type: 'setMidBanner',
  payload
});

export {
  initialState,
  reducer,
  setBannerLoading,
  setBannerList,
  setRecommendLoading,
  setRecommendList,
  setMidBanner
};
